export const propertyTypeStatisticSummaryModel = (data) => ({
    name: data.name,
    value: data.value,
});